<template>
    <div class="main-wrapper background--gradient">
        <div class="grid">
            <div class="header header--subpage">
              <button style="border-radius: 0; border: none; background-color: transparent;" @click="stop(); $emit('home')"><img src="/assets/icons/mimi-logo.svg"></button>
                <button class="btn--back" @click="stop(); $emit('back')">Back</button>
            </div>
            <div class="demo">
                <div class="demo-wrapper">
                    <div class="personas-wrapper">
                        <div class="personas">
                            <button class="persona" :disabled="personaIdx == 1" @click="set_persona(1)">
                                <div class="persona-description">
                                    <p class="persona__hearing">Good hearing</p>
                                    <p class="persona__name">Kevin</p>
                                </div>
                                <div class="persona__image-wrapper">
                                    <div class="persona__image"><img src="/assets/images/image-kevin.png"></div>
                                </div>                        
                            </button>
                            <button class="persona" :disabled="personaIdx == 2" @click="set_persona(2)">
                                <div class="persona-description">
                                    <p class="persona__hearing">Average hearing</p>
                                    <p class="persona__name">Lisa</p>
                                </div>
                                <div class="persona__image-wrapper">
                                    <div class="persona__image"><img src="/assets/images/image-lisa.png"></div>
                                </div>                        
                            </button>
                            <button class="persona" :disabled="personaIdx == 3" @click="set_persona(3)">
                                <div class="persona-description">
                                    <p class="persona__hearing">Limited hearing</p>
                                    <p class="persona__name">Matteo</p>
                                </div>
                                <div class="persona__image-wrapper">
                                    <div class="persona__image"><img src="/assets/images/image-mateo.png"></div>
                                </div>                        
                            </button>
                            <div id="personas__curve"></div>
                        </div>
                    </div>
                        <div class="audio-wrapper">
                            <div class="image">
                                <!---Personalization circles--->
                                <div v-if="isPlaying && isProcessing">
                                    <div v-if="personaIdx == 0 && trackIdx == 0" :class="{personalization0onElectronic: isProcessing, personalization0off: !isProcessing}"></div>
                                    <div v-if="personaIdx == 0 && trackIdx == 1" :class="{personalization0onPop: isProcessing, personalization0off: !isProcessing}"></div>
                                    <div v-if="personaIdx == 0 && trackIdx == 2" :class="{personalization0onPodcast: isProcessing, personalization0off: !isProcessing}"></div>
                                    <div v-if="personaIdx == 0 && trackIdx == 3" :class="{personalization0onMovie: isProcessing, personalization0off: !isProcessing}"></div>
                                    <div v-if="personaIdx == 1 && trackIdx == 0" :class="{personalization1onElectronic: isProcessing, personalization0off: !isProcessing}"></div>
                                    <div v-if="personaIdx == 1 && trackIdx == 1" :class="{personalization1onPop: isProcessing, personalization0off: !isProcessing}"></div>
                                    <div v-if="personaIdx == 1 && trackIdx == 2" :class="{personalization1onPodcast: isProcessing, personalization0off: !isProcessing}"></div>
                                    <div v-if="personaIdx == 1 && trackIdx == 3" :class="{personalization1onMovie: isProcessing, personalization0off: !isProcessing}"></div>
                                    <div v-if="personaIdx == 2 && trackIdx == 0" :class="{personalization2onElectronic: isProcessing, personalization0off: !isProcessing}"></div>
                                    <div v-if="personaIdx == 2 && trackIdx == 1" :class="{personalization2onPop: isProcessing, personalization0off: !isProcessing}"></div>
                                    <div v-if="personaIdx == 2 && trackIdx == 2" :class="{personalization2onPodcast: isProcessing, personalization0off: !isProcessing}"></div>
                                    <div v-if="personaIdx == 2 && trackIdx == 3" :class="{personalization2onMovie: isProcessing, personalization0off: !isProcessing}"></div>
                                    <div v-if="personaIdx == 3 && trackIdx == 0" :class="{personalization3onElectronic: isProcessing, personalization0off: !isProcessing}"></div>
                                    <div v-if="personaIdx == 3 && trackIdx == 1" :class="{personalization3onPop: isProcessing, personalization0off: !isProcessing}"></div>
                                    <div v-if="personaIdx == 3 && trackIdx == 2" :class="{personalization3onPodcast: isProcessing, personalization0off: !isProcessing}"></div>
                                    <div v-if="personaIdx == 3 && trackIdx == 3" :class="{personalization3onMovie: isProcessing, personalization0off: !isProcessing}"></div>
                                </div>
                                <!---Original circles--->
                                <div v-if="personaIdx == 0 && trackIdx == 0" :class="{original0onElectronic: isPlaying, original0off: !isPlaying}"></div>
                                <div v-if="personaIdx == 0 && trackIdx == 1" :class="{original0onPop: isPlaying, original0off: !isPlaying}"></div>
                                <div v-if="personaIdx == 0 && trackIdx == 2" :class="{original0onPodcast: isPlaying, original0off: !isPlaying}"></div>
                                <div v-if="personaIdx == 0 && trackIdx == 3" :class="{original0onMovie: isPlaying, original0off: !isPlaying}"></div>
                                <div v-if="personaIdx == 1 && trackIdx == 0" :class="{original1onElectronic: isPlaying, original0off: !isPlaying}"></div>
                                <div v-if="personaIdx == 1 && trackIdx == 1" :class="{original1onPop: isPlaying, original0off: !isPlaying}"></div>
                                <div v-if="personaIdx == 1 && trackIdx == 2" :class="{original1onPodcast: isPlaying, original0off: !isPlaying}"></div>
                                <div v-if="personaIdx == 1 && trackIdx == 3" :class="{original1onMovie: isPlaying, original0off: !isPlaying}"></div>
                                <div v-if="personaIdx == 2 && trackIdx == 0" :class="{original2onElectronic: isPlaying, original0off: !isPlaying}"></div>
                                <div v-if="personaIdx == 2 && trackIdx == 1" :class="{original2onPop: isPlaying, original0off: !isPlaying}"></div>
                                <div v-if="personaIdx == 2 && trackIdx == 2" :class="{original2onPodcast: isPlaying, original0off: !isPlaying}"></div>
                                <div v-if="personaIdx == 2 && trackIdx == 3" :class="{original2onMovie: isPlaying, original0off: !isPlaying}"></div>
                                <div v-if="personaIdx == 3 && trackIdx == 0" :class="{original3onElectronic: isPlaying, original0off: !isPlaying}"></div>
                                <div v-if="personaIdx == 3 && trackIdx == 1" :class="{original3onPop: isPlaying, original0off: !isPlaying}"></div>
                                <div v-if="personaIdx == 3 && trackIdx == 2" :class="{original3onPodcast: isPlaying, original0off: !isPlaying}"></div>
                                <div v-if="personaIdx == 3 && trackIdx == 3" :class="{original3onMovie: isPlaying, original0off: !isPlaying}"></div>
                                <!---Images--->
                                <img v-if="personaIdx == 0" src="/assets/images/image-stella.png">
                                <img v-if="personaIdx == 1" src="/assets/images/image-kevin.png">
                                <img v-if="personaIdx == 2" src="/assets/images/image-lisa.png">
                                <img v-if="personaIdx == 3" src="/assets/images/image-mateo.png">            
                            </div>
                            <div class="audio">
                                <div class="play">
                                    <input class="transport" v-model="isPlaying" @click="toggle_play()" type="checkbox" id="play" />
                                    <label id="play-label" for="play">Play</label>
                                </div>
                                <div class="personalization">
                                    <input class="processor" v-model="isProcessing" :disabled="!isPlaying" @click="toggle_processor()" type="checkbox" id="personalization" />
                                    <label id="personalization-label" for="personalization">Mimi</label>
                                </div>
                            </div>
                        </div>
                    <div class="tracks-wrapper">
                        <div class="tracks">
                            <button class="track" :disabled="trackIdx == 0" @click="set_track(0)">
                                <div class="track-description">
                                    <p class="track__type">Electronic</p>
                                    <!-- <p class="track__name">Four Tet • Lush</p> -->
                                </div>
                            </button>
                            <button class="track" :disabled="trackIdx == 1" @click="set_track(1)">
                                <div class="track-description">
                                    <p class="track__type">Pop</p>
                                    <!-- <p class="track__name">So Hot • Caroline Polachek</p> -->
                                </div>                        
                            </button>
                            <button class="track" :disabled="trackIdx == 2" @click="set_track(2)">
                                <div class="track-description">
                                    <p class="track__type">Podcast</p>
                                    <!-- <p class="track__name">Tim • About Mimi</p> -->
                                </div>
                            </button>
                            <button class="track" :disabled="trackIdx == 3" @click="set_track(3)">
                                <div class="track-description">
                                    <p class="track__type">Movie</p>
                                    <!-- <p class="track__name">Trailer • The Social Network</p> -->
                                </div>
                            </button>
                            <div id="tracks__curve"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer footer--subpage">
                <button class="btn" @click="stop(); $emit('b2c')">For You</button>
                <button class="btn" @click="stop(); $emit('b2b')">For Partners</button>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'Interactive',
    props: [
        "audioCtx",
        "gainNodes",
        "gain_delta"
    ],
    data() {
        return {
            personaIdx: 1,
            trackIdx: 1,
            isPlaying: false,
            isProcessing: false,
            NUM_TRACKS: 4,
            NUM_PERSONAS: 3
        };
    },
    mounted() {
        this.set_gains()
        if(this.isPlaying) {
            this.play()
        } else {
            this.stop()
        }
        
    },
    methods: {
        play() {
            this.isPlaying = true
            this.audioCtx.resume();
        },
        stop() {
            this.isPlaying = false
            this.audioCtx.suspend();
        },
        toggle_play() {
            this.isPlaying = !this.isPlaying

            if (this.isPlaying) {
                this.audioCtx.resume();
            } else {
                this.audioCtx.suspend();
            }
        },
        toggle_processor() {
            this.isProcessing = !this.isProcessing
            this.set_gains()
        },
        processor_off() {
            if(this.isProcessing) {
                this.toggle_processor()
            }
        },
        set_track(value) {
            this.trackIdx = value
            this.set_gains()
        },
        set_persona(value) {
            this.processor_off()
            this.personaIdx = value
            this.set_gains()
        },
        set_gains() {
            let target = this.NUM_PERSONAS * this.trackIdx + this.personaIdx-1
            if (this.isProcessing) {
                target += this.NUM_PERSONAS * this.NUM_TRACKS
            }

            for (var ii = 0; ii < this.gainNodes.length; ii++) {
                this.gainNodes[ii].gain.value = 0;
            }

            const gainTarget = this.isProcessing ? Math.pow(10.0, this.gain_delta / 20.0) : 1.
            // console.log(gainTarget)
            this.gainNodes[target].gain.value = gainTarget;
        },

        advance_to_next(){
            if (this.isPlaying) {
                this.stop()
            }

            this.$emit('next')

        }
    },
}
</script>

<style>

:root {
  --elec_bpm: 134;
  --pop_bpm: 110;
  --elec_period_ms: calc( 500.0ms * calc( 60 / var(--elec_bpm) ));
  --pop_period_ms: calc( 500.0ms * calc( 60 / var(--pop_bpm) ));
  --podcast_period_ms: 600ms;
  --movie_period_ms: 400ms;
}

.main-wrapper {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
}

.grid {
    height: 95vh;
    width: 100%;
    display: grid;
    grid-template-rows: 1fr 6fr 1fr;
}

.background--gradient {
    background-image: url("/assets/images/background--gradient.jpg");
    background-repeat: no-repeat;
    background-position: bottom left;
    background-size: cover;
}

.header {
    padding: 2rem;
}

.demo-wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    height: 100%;
}

.personas-wrapper {
    display: flex;
    justify-content: flex-end;
}

.personas {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    position: relative;
    z-index: 1;
}

button.persona {
    display: flex;
    align-items: center;
    background-color: transparent;
    border: none;
    text-align: right;
    z-index: 1;
}

.persona:not(:last-of-type) {
    margin-bottom: 7rem;
}

.persona:nth-of-type(2) {
    margin-right: 4rem;
}

.persona:nth-of-type(3) {
    margin-right: -0.5rem;
}

.persona__hearing,
.persona__name,
.track__type,
.track__name {
    font-size: 1.25rem;
    line-height: 1.75rem;
    font-weight: 400;
    color: #333;
}

.persona__hearing,
.track__type {
    font-weight: 600;
    letter-spacing: -0.25px;
}

.persona__image-wrapper {
    width: 5rem;
    height: 5rem;
    display: grid;
    align-items: center;
    justify-content: center;
    margin-left: 1rem;
}

.persona__image {
    width: 3rem;
    height: 3rem;
    border-radius: 3rem;
    background-color: #FFFFFF;
    border: 0 solid transparent;
    transition: width 0.3s, height 0.3s;
}

.persona__image img {
    width: 100%;
    height: auto;
}

.persona:disabled .persona__image {
    width: 5rem;
    height: 5rem;
    border-radius: 5rem;
    border: 4px solid #7E47FF;
    transition: width 0.3s, height 0.3s;
    transform: translateY(-4px);
}

#personas__curve {
    position: absolute;
    width: 280px;
    height: 280px;
    border-top: 2px solid #B695FF;
    border-left: 2px solid #B695FF;
    border-top-left-radius: 280px;
    float: left;
    margin-left: 100px;
    transform: rotate(-46deg);
    top: 6rem;
    right: -7rem;
    z-index: 0;
}

.audio-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.audio {
    width: 25rem;
    height: 25rem;
    border-radius: 25rem;
    position: relative;
}

.image {
    position: absolute;
    top: 0;
    width: 25rem;
    height: 25rem;
    border-radius: 25rem;
    z-index: 0;
}

.image img {
    width: 100%;
    height: auto;
    position: relative;
}

.audio .play {
    position: absolute;
    bottom: -3rem;
    left: 50%;
    transform: translateX(-50%);
}


.audio .personalization {
    position: absolute;
    top: -2.5rem;
    left: 50%;
    transform: translateX(-50%);
}

#play {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    appearance: none;
    background-color: #7E47FF;
    width: 6rem;
    height: 6rem;
    border-radius: 6rem;
    z-index: 1;
}

#play::before {
    display: block;
    content: ' ';
    background-image: url('/assets/icons/play.svg');
    background-size: 2rem 2rem;
    height: 2rem;
    width: 2rem;
    margin-left: 0.25rem;
}

#play:checked::before {
    display: block;
    content: ' ';
    background-image: url('/assets/icons/pause.svg');
    background-size: 2rem 2rem;
    height: 2rem;
    width: 2rem;
    margin-left: 0;
}

#personalization:disabled,
#personalization:disabled:checked {
    appearance: none;
    background-color: #E0E0E0;
    width: 8.5rem;
    height: 5rem;
    border-radius: 5rem;
    position: relative;
    transition: background-color 0.3s;
    z-index: 1;
}

#personalization {
    appearance: none;
    background-color: #333333;
    width: 8.5rem;
    height: 5rem;
    border-radius: 5rem;
    position: relative;
    transition: background-color 0.3s;
    z-index: 1;
}

#personalization:checked {
    background-color: #7E47FF;
    transition: background-color 0.3s;
}

#personalization::before {
    display: block;
    content: ' ';
    background-color: #FFF;
    height: 4.4rem;
    width: 4.4rem;
    border-radius: 4.4rem;
    margin-left: 0.3rem;
    margin-top: 0.3rem;
    transition: margin-left 0.3s;
}

#personalization::after {
    display: block;
    content: 'Without Mimi';
    position: absolute;
    font-size: 0.75rem;
    font-weight: 600;
    color: #333;
    top: -1.25rem;
    left: 20%;
}

#personalization:checked::before {
    display: block;
    content: ' ';
    background-color: #FFF;
    height: 4.4rem;
    width: 4.4rem;
    border-radius: 4.4rem;
    margin-left: 3.75rem;
    margin-top: 0.3rem;
    transition: margin-left 0.3s;
}

#personalization:checked::after {
    display: block;
    content: 'With Mimi';
    position: absolute;
    font-size: 0.75rem;
    font-weight: 600;
    color: #333;
    top: -1.25rem;
    left: 50%;
    transform: translateX(-50%);
}

#play-label,
#personalization-label {
    display: none;
}

.quotes-wrapper {
    position: absolute;
    bottom: 0;
    transform: translateY(220%);
    font-size: 1.5rem;
    width: 150%;
    text-align: center;
}

.tracks {
    display: flex;
    flex-direction: column;
    position: relative;
}

button.track {
    text-align: left;
    background-color: transparent;
    border: none;
    height: 5rem;
    position: relative;
    display: flex;
    align-items: center;
}

.track:not(:last-of-type) {
    margin-bottom: 3.5rem;
}

.track:nth-of-type(2),
.track:nth-of-type(3) {
    margin-left: 5rem;
}

.track::before {
    position: absolute;
    z-index: 1;
    content: '';
    display: inline-block;
    width: 1rem;
    height: 1rem;
    border-radius: 1rem;
    margin-left: 0.5rem;
    background-color: #B695FF;
}

.track:disabled::before {
    background-color: #7E47FF;
}

.track::after {
    position: absolute;
    z-index: 1;
    content: '';
    display: inline-block;
    width: 1.5rem;
    height: 1.5rem;
    border: 0.25rem solid transparent;
    border-radius: 1.5rem;
    background-color: transparent;
    transition: border 0.3s;
}

.track:disabled::after {
    border: 0.25rem solid #7E47FF;
    transition: border 0.3s;
}

.track-description {
    margin-left: 3rem;
}

#tracks__curve {
    position: absolute;
    width: 285px;
    height: 285px;
    border-top: 2px solid #B695FF;
    border-left: 2px solid #B695FF;
    border-top-left-radius: 285px;
    float: left;
    margin-left: 100px;
    transform: rotate(135deg);
    top: 6.4rem;
    left: -14rem;
    z-index: 0;
}

.footer {
    padding: 2rem;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
}

.footer .btn {
    font-size: 1rem;
    height: 2.5rem;
    padding: 0 1.2rem;
    border-radius: 3rem;
    font-weight: 500;
    background-color: #333;
    color: #FFF;
    border: none;
    cursor: pointer;
}

.footer--subpage .btn:not(:first-of-type) {
    margin-left: 1rem;
}

.original0onElectronic {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.4;
    width: 26rem;
    height: 26rem;
    border-radius: 26rem;
    top: -0.5rem;
    left: -0.5rem;
    animation: original0 var(--elec_period_ms) infinite alternate;
}

.original0onPop {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.4;
    width: 26rem;
    height: 26rem;
    border-radius: 26rem;
    top: -0.5rem;
    left: -0.5rem;
    animation: original0 var(--pop_period_ms) infinite alternate;
}

.original0onPodcast {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.4;
    width: 26rem;
    height: 26rem;
    border-radius: 26rem;
    top: -0.5rem;
    left: -0.5rem;
    animation: original0 var(--podcast_period_ms) infinite alternate;
}

.original0onMovie {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.4;
    width: 26rem;
    height: 26rem;
    border-radius: 26rem;
    top: -0.5rem;
    left: -0.5rem;
    animation: original0 var(--movie_period_ms) infinite alternate;
}

.original1onElectronic {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.4;
    width: 27rem;
    height: 27rem;
    border-radius: 26rem;
    top: -1rem;
    left: -1rem;
    animation: original0 var(--elec_period_ms) infinite alternate;
}

.original1onPop {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.4;
    width: 27rem;
    height: 27rem;
    border-radius: 26rem;
    top: -1rem;
    left: -1rem;
    animation: original0 var(--pop_period_ms) infinite alternate;
}

.original1onPodcast {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.4;
    width: 27rem;
    height: 27rem;
    border-radius: 26rem;
    top: -1rem;
    left: -1rem;
    animation: original0 var(--podcast_period_ms) infinite alternate;
}

.original1onMovie {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.4;
    width: 27rem;
    height: 27rem;
    border-radius: 26rem;
    top: -1rem;
    left: -1rem;
    animation: original0 var(--movie_period_ms) infinite alternate;
}

.original2onElectronic {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.4;
    width: 28rem;
    height: 28rem;
    border-radius: 28rem;
    top: -1.5rem;
    left: -1.5rem;
    animation: original0 var(--elec_period_ms) infinite alternate;
}

.original2onPop {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.4;
    width: 28rem;
    height: 28rem;
    border-radius: 28rem;
    top: -1.5rem;
    left: -1.5rem;
    animation: original0 var(--pop_period_ms) infinite alternate;
}

.original2onPodcast {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.4;
    width: 28rem;
    height: 28rem;
    border-radius: 28rem;
    top: -1.5rem;
    left: -1.5rem;
    animation: original0 var(--podcast_period_ms) infinite alternate;
}

.original2onMovie {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.4;
    width: 28rem;
    height: 28rem;
    border-radius: 28rem;
    top: -1.5rem;
    left: -1.5rem;
    animation: original0 var(--movie_period_ms) infinite alternate;
}

.original3onElectronic {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.4;
    width: 29rem;
    height: 29rem;
    border-radius: 29rem;
    top: -2rem;
    left: -2rem;
    animation: original0 var(--elec_period_ms) infinite alternate;
}

.original3onPop {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.4;
    width: 29rem;
    height: 29rem;
    border-radius: 29rem;
    top: -2rem;
    left: -2rem;
    animation: original0 var(--pop_period_ms) infinite alternate;
}

.original3onPodcast {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.4;
    width: 29rem;
    height: 29rem;
    border-radius: 29rem;
    top: -2rem;
    left: -2rem;
    animation: original0 var(--podcast_period_ms) infinite alternate;
}

.original3onMovie {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.4;
    width: 29rem;
    height: 29rem;
    border-radius: 29rem;
    top: -2rem;
    left: -2rem;
    animation: original0 var(--movie_period_ms) infinite alternate;
}

.original0off,
.original1off {
    display: none;
}

.personalization0onElectronic {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.2;
    width: 26rem;
    height: 26rem;
    border-radius: 26rem;
    top: -0.5rem;
    left: -0.5rem;
    z-index: 0;
    animation: personalization0 var(--elec_period_ms) infinite alternate;
}

.personalization0onPop {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.2;
    width: 26rem;
    height: 26rem;
    border-radius: 26rem;
    top: -0.5rem;
    left: -0.5rem;
    z-index: 0;
    animation: personalization0 var(--pop_period_ms) infinite alternate;
}

.personalization0onPodcast {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.2;
    width: 26rem;
    height: 26rem;
    border-radius: 26rem;
    top: -0.5rem;
    left: -0.5rem;
    z-index: 0;
    animation: personalization0 var(--podcast_period_ms) infinite alternate;
}

.personalization0onMovie {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.2;
    width: 26rem;
    height: 26rem;
    border-radius: 26rem;
    top: -0.5rem;
    left: -0.5rem;
    z-index: 0;
    animation: personalization0 var(--movie_period_ms) infinite alternate;
}

.personalization1onElectronic {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.2;
    width: 27rem;
    height: 27rem;
    border-radius: 27rem;
    top: -1rem;
    left: -1rem;
    z-index: 0;
    animation: personalization0 var(--elec_period_ms) infinite alternate;
}

.personalization1onPop {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.2;
    width: 27rem;
    height: 27rem;
    border-radius: 27rem;
    top: -1rem;
    left: -1rem;
    z-index: 0;
    animation: personalization0 var(--pop_period_ms) infinite alternate;
}

.personalization1onPodcast {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.2;
    width: 27rem;
    height: 27rem;
    border-radius: 27rem;
    top: -1rem;
    left: -1rem;
    z-index: 0;
    animation: personalization0 var(--podcast_period_ms) infinite alternate;
}

.personalization1onMovie {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.2;
    width: 27rem;
    height: 27rem;
    border-radius: 27rem;
    top: -1rem;
    left: -1rem;
    z-index: 0;
    animation: personalization0 var(--movie_period_ms) infinite alternate;
}

.personalization2onElectronic {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.2;
    width: 28rem;
    height: 28rem;
    border-radius: 28rem;
    top: -1.5rem;
    left: -1.5rem;
    z-index: 0;
    animation: personalization0 var(--elec_period_ms) infinite alternate;
}

.personalization2onPop {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.2;
    width: 28rem;
    height: 28rem;
    border-radius: 28rem;
    top: -1.5rem;
    left: -1.5rem;
    z-index: 0;
    animation: personalization0 var(--pop_period_ms) infinite alternate;
}

.personalization2onPodcast {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.2;
    width: 28rem;
    height: 28rem;
    border-radius: 28rem;
    top: -1.5rem;
    left: -1.5rem;
    z-index: 0;
    animation: personalization0 var(--podcast_period_ms) infinite alternate;
}

.personalization2onMovie {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.2;
    width: 28rem;
    height: 28rem;
    border-radius: 28rem;
    top: -1.5rem;
    left: -1.5rem;
    z-index: 0;
    animation: personalization0 var(--movie_period_ms) infinite alternate;
}

.personalization3onElectronic {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.2;
    width: 29rem;
    height: 29rem;
    border-radius: 29rem;
    top: -2rem;
    left: -2rem;
    z-index: 0;
    animation: personalization0 var(--elec_period_ms) infinite alternate;
}

.personalization3onPop {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.2;
    width: 29rem;
    height: 29rem;
    border-radius: 29rem;
    top: -2rem;
    left: -2rem;
    z-index: 0;
    animation: personalization0 var(--pop_period_ms) infinite alternate;
}

.personalization3onPodcast {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.2;
    width: 29rem;
    height: 29rem;
    border-radius: 29rem;
    top: -2rem;
    left: -2rem;
    z-index: 0;
    animation: personalization0 var(--podcast_period_ms) infinite alternate;
}

.personalization3onMovie {
    position: absolute;
    background-color: #7E47FF;
    opacity: 0.2;
    width: 29rem;
    height: 29rem;
    border-radius: 29rem;
    top: -2rem;
    left: -2rem;
    z-index: 0;
    animation: personalization0 var(--movie_period_ms) infinite alternate;
}

.personalization0off,
.personalization1off {
    display: none;
}

.btn--back {
    padding: 0 1.2rem;
}

@keyframes original0 {
  from {-webkit-transform: scale(1.0);}
  to {-webkit-transform: scale(1.05);}
}

@keyframes personalization0 {
  from {-webkit-transform: scale(1.0);}
  to {-webkit-transform: scale(1.15);}
}

@keyframes original1 {
  from {-webkit-transform: scale(1.0);}
  to {-webkit-transform: scale(1.1);}
}

@keyframes personalization1 {
  from {-webkit-transform: scale(1.0);}
  to {-webkit-transform: scale(1.25);}
}

</style>